import { Controller } from "@hotwired/stimulus"

// Controller for managing the selection of messages in the inbox
export default class extends Controller {
  static get targets() {
    return ["messageRow", "inboxDetails"]
  }

  removeSelectedClassInOtherMessages(event) {
    if (event.target.dataset.blockSelect) {
      return
    }

    this.messageRowTargets.forEach((messageRow) => {
      if (messageRow.classList.contains("selected")) {
        messageRow.classList.remove("selected")
        messageRow.classList.add("disabled")
      }
    })

    this.inboxDetailsTarget.scrollIntoView({ behavior: "smooth" })
  }
}
